import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
function FaqItem({
  title,
  children,
  isOpen,
  onClick
}: {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border-b border-white/10" data-id="element-250">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" onClick={onClick} data-id="element-251">
        <span className={`text-lg font-medium transition-colors ${isOpen ? 'text-[#c9a84c]' : 'text-white group-hover:text-[#c9a84c]'}`} data-id="element-252">
          {title}
        </span>
        <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#c9a84c]' : 'text-white/50'}`} data-id="element-253" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-254">
        <p className="text-white/70 leading-relaxed" data-id="element-255">{children}</p>
      </div>
    </div>;
}
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'How much does website design cost in Ireland?',
    a: 'Most agencies charge €2,000–€5,000+ for a standard business website. Freelancers range from €800–€2,000. Our launch package is €249 one-time because we use AI-powered tools that let us build professional sites faster and pass the savings to you. This includes a custom design, mobile responsiveness, SEO setup, 1 year of hosting, and direct support. There are no hidden fees or monthly charges.'
  }, {
    q: 'How long does it take to launch my website?',
    a: 'Most websites are ready within 48–72 hours after we receive your content (text, images, logo). If you need help writing copy or sourcing images, we can guide you through the process. The faster you provide materials, the faster we deliver. Rush delivery is also available if you need your site live urgently.'
  }, {
    q: 'Will my site rank on Google?',
    a: 'Every website we build includes an SEO-friendly structure with proper heading hierarchy, fast loading speeds, mobile responsiveness, and clean code — all key ranking factors for Google Ireland. We also set up basic on-page SEO including meta titles, descriptions, and alt text. For businesses targeting local searches like "electrician Dublin" or "restaurant near me", our structure gives you a strong foundation to rank.'
  }, {
    q: 'Do I need hosting?',
    a: 'No need to worry about hosting — 1 full year of fast, reliable hosting is included in every package at no extra cost. After the first year, hosting renewal is available at an affordable rate. We handle all the technical setup so you can focus on running your business.'
  }, {
    q: 'Can you redesign an existing site?',
    a: "Absolutely. If you already have a website that looks outdated or isn't converting visitors into customers, we can rebuild it from scratch with a modern, professional design. We'll keep your existing domain and can migrate any content you want to preserve. The result is a faster, better-looking site that works harder for your business."
  }, {
    q: 'What support comes with the service?',
    a: 'Every package includes 1 year of direct support via WhatsApp. You can reach us for help with content updates, technical questions, or guidance on using the AI editing tools. We also include 100 AI editing requests per month so you can make changes to your site without needing a developer. We typically respond within a few hours.'
  }];
  return <section id="faq" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#080808'
  }} data-id="element-256">
      <div className="max-w-3xl mx-auto" data-id="element-257">
        <div className="text-center mb-12 reveal" data-id="element-258">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-259">
            Frequently Asked Questions About Website Design in Ireland
          </h2>
        </div>
        <div className="space-y-2 reveal" data-id="element-260">
          {faqs.map((faq, idx) => <FaqItem key={idx} title={faq.q} isOpen={openIndex === idx} onClick={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-261">
              {faq.a}
            </FaqItem>)}
        </div>
      </div>
      <SectionDivider data-id="element-262" />
    </section>;
}